import localStorage from 'localStorage'
import { API_URL_PREFIX } from './http.constants'
import { getJwtToken } from '../../features/userContext/userContext.selectors'
// import { getState } from "../store";
// import * as actionTypes from "../userContext/userContext.actionTypes";
import FileSaver from 'file-saver'

export default {
	get,
	post,
	put,
	patch,
	delete: callDelete,
}

const ASYNC_DELAY = 2000

function get(url, config, { stubSuccess, stubError } = {}, getState) {
	return doFetch(url, config, { stubSuccess, stubError }, getState)
}

function post(
	url,
	config,
	{ stubSuccess, stubError } = {},
	getState,
	allowDownload,
	fileName,
	renderFileInNewTab
) {
	config = {
		...config,
		method: 'POST',
	}

	return doFetch(
		url,
		config,
		{ stubSuccess, stubError },
		getState,
		allowDownload,
		fileName,
		renderFileInNewTab
	)
}

function put(url, config, { stubSuccess, stubError } = {}, getState) {
	config = {
		...config,
		method: 'PUT',
	}

	return doFetch(url, config, { stubSuccess, stubError }, getState)
}

function patch(url, config, { stubSuccess, stubError } = {}, getState) {
	config = {
		...config,
		method: 'PATCH',
	}

	return doFetch(url, config, { stubSuccess, stubError }, getState)
}

function callDelete(url, config, { stubSuccess, stubError } = {}, getState) {
	config = {
		...config,
		method: 'DELETE',
	}

	return doFetch(url, config, { stubSuccess, stubError }, getState)
}

// If stubSuccess or stubError is defined then we will fake a successful call to the
// server and return stubSuccess as the response. This allows for easily
// faking calls during development when APIs aren't ready. A warning
// will be written out for each stubbed response to help prevent forgetting
// about the stubs.
function doFetch(
	url,
	config,
	{ stubSuccess, stubError } = {},
	getState,
	allowDownload,
	fileName,
	renderFileInNewTab
) {
	if (!url) {
		throw new Error('You must specify a url')
	}

	if (import.meta.env.NODE_ENV !== 'test') {
		if (stubSuccess) {
			return new Promise((resolve) =>
				setTimeout(() => {
					console.warn(`Stubbed service call made to url: ${url}`)
					resolve(stubSuccess)
				}, ASYNC_DELAY)
			)
		}

		if (stubError) {
			return new Promise((resolve, reject) =>
				setTimeout(() => {
					console.warn(`Stubbed service error was returned from url: ${url}`)
					reject(stubError)
				}, ASYNC_DELAY)
			)
		}
	}
	return fetch(buildUrl(url), addJwtToken(config, getState)).then(
		(response) => {
			if (response.headers) {
				const authHeader = response.headers.get('Authorization')

				setJwtTokenFromHeaderResponse(authHeader)
				// updateSessionToken(parseJwtTokenFromHeader(authHeader));
			}

			if (response.ok) {
				const noContent = 204
				if (
					response.headers &&
					response.headers.map &&
					response.headers.map['content-type'].includes('stream')
				) {
					return response
				} else if (response.status === noContent) {
					return Promise.resolve('No Content')
				} else if (allowDownload) {
					response.blob().then((myBlob) => {
						const objectURL = URL.createObjectURL(myBlob)
						FileSaver.saveAs(objectURL, fileName)
					})
					return Promise.resolve('File Downloaded')
				} else if (renderFileInNewTab) {
					response.blob().then((myBlob) => {
						const objectURL = URL.createObjectURL(myBlob)
						window.open(objectURL, '_blank')
					})
					return Promise.resolve('File Rendered')
				}
			const warningMessage = response.headers.get('X-Warning-Message')
			return response.json().then((body) => {
				if (warningMessage) {
					body._warningMessage = warningMessage
				}
				return body
			})
		}

			const unauthorized = 401
			if (response.status === unauthorized) {
				// All else failed so redirect user ot FMS to reauthenticate
				localStorage.removeItem('jwtToken')
				// response.json().then(() => redirectToSignOut());
			}

			const BAD_REQUEST = 400
			const POST = 'POST'
			const endpointUrl = API_URL_PREFIX ? response.url : url
			const urlForBackOfficeUsers = API_URL_PREFIX
				? `${API_URL_PREFIX}/api/backOfficeUsers`
				: 'api/backOfficeUsers'
			const urlForAccounts = API_URL_PREFIX
				? `${API_URL_PREFIX}/api/accounts`
				: 'api/accounts'

			if (
				response.status === BAD_REQUEST &&
				(endpointUrl === urlForAccounts ||
					endpointUrl === urlForBackOfficeUsers) &&
				config.method === POST
			) {
				return response
			}

			if (
				response.status === BAD_REQUEST &&
				endpointUrl.startsWith(urlForAccounts) &&
				config.method === undefined
			) {
				return response.text()
			}

			return Promise.reject(response)
		}
	)
}

function buildUrl(url) {
	return API_URL_PREFIX ? `${API_URL_PREFIX}/${url}` : url
}

function addJwtToken(config, getState) {
	const jwtToken = getJwtToken(getState())
	if (!jwtToken || !config) {
		return config
	}

	const authorization = `Bearer ${jwtToken}`
	return {
		...config,
		headers: {
			...config.headers,
			Authorization: authorization,
		},
	}
}

function setJwtTokenFromHeaderResponse(authorizationHeader) {
	const jwtToken = parseJwtTokenFromHeader(authorizationHeader)
	if (jwtToken) {
		localStorage.setItem('jwtToken', jwtToken)
	} else {
		localStorage.removeItem('jwtToken')
	}
}

function parseJwtTokenFromHeader(authorizationHeader) {
	if (!authorizationHeader) {
		return
	}
	const tokens = authorizationHeader.match(/\S+/g)

	// We are getting the second token because the first token will be Bearer.
	// EX: Bearer woeirweoirjw....
	return tokens.length > 1 ? tokens[1] : null
}

// const updateSessionToken = token => dispatch => {
// TODO: Do we need this?
// dispatch({
//   type: actionTypes.JWT_TOKEN_ASYNC.RECEIVED,
//   payload: token
// });
// };
